module.exports = __webpack_public_path__ + "static/media/deliverybox-logo.a95f4430.svg";